/**
 * Copyright © 2026 Adnuntius AS.
 */
import {LocalStorage} from "./local-storage";
import * as _ from "lodash";
import {Injectable} from '@angular/core';

type Pausing = {
  isAllowed: boolean;
};

@Injectable({providedIn: 'root'})
export class LocalPausing {
  private static readonly LOCAL_PAUSING_STORAGE_KEY = 'user.pausing';
  pausing: Pausing;

  constructor() {
    this.refresh();
  }

  private save() {
    LocalStorage.obtain().setItem(LocalPausing.LOCAL_PAUSING_STORAGE_KEY, this.pausing);
  }

  private refresh() {
    const localStorageInfo = LocalStorage.obtain().getItem(LocalPausing.LOCAL_PAUSING_STORAGE_KEY);
    this.pausing = _.isEmpty(localStorageInfo) ? _.isEmpty(this.pausing) ? {} : this.pausing : localStorageInfo;
  }

  destroy() {
    this.pausing = null;
    return LocalStorage.obtain().remove(LocalPausing.LOCAL_PAUSING_STORAGE_KEY);
  }

  set(value: boolean) {
    this.refresh();
    this.pausing.isAllowed = value;
    this.save();
  }

  get() {
    this.refresh();
    return this.pausing.isAllowed;
  }
}
